import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "control" }
const _hoisted_2 = { class: "field has-addons" }
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "icon" }

import Toast from '@/shared/services/toast';
import { useClipboard } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadonlyCopyableField',
  props: {
  readonlyValue: {
    type: String,
    required: true,
  },
  onCopyMessage: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { copy, isSupported } = useClipboard();

function copyToClipboard() {
  if (isSupported.value) {
    copy(props.readonlyValue);
    Toast.showInfo(props.onCopyMessage);
  } else {
    Toast.showError('Clipboard not supported');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          class: "input",
          type: "text",
          disabled: "",
          value: __props.readonlyValue
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("button", {
          class: "button is-info",
          onClick: copyToClipboard
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_font_awesome_icon, { icon: "copy" })
          ])
        ])
      ])
    ])
  ]))
}
}

})